module.exports = __webpack_public_path__ + "static/media/shuaifeng.3ec3b324.png";